/* Eversfield product page (Oct 26): swipe rows with a progress line.
   Each [data-eo26-swipe] holds a scrolling row and a line underneath. The darker part of the line shows how much of
   the row is in view and where you are; it hides itself when everything fits. With a mouse you can drag the row. */
(() => {
  const init = (root) => {
    if (root.dataset.eo26Ready) return;
    root.dataset.eo26Ready = '1';
    const row = root.querySelector('[data-eo26-swipe-row]');
    const bar = root.querySelector('.eo26-swipe__bar');
    if (!row || !bar) return;
    const thumb = bar.querySelector('span');

    const update = () => {
      const visible = row.clientWidth / row.scrollWidth;
      bar.hidden = visible >= 0.999;
      const max = row.scrollWidth - row.clientWidth;
      thumb.style.width = `${visible * 100}%`;
      thumb.style.left = `${max > 0 ? (row.scrollLeft / max) * (100 - visible * 100) : 0}%`;
    };
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(row);
    update();

    // Drag to scroll with a mouse (touch already swipes). Ignores drags that start on links, buttons or forms.
    let startX = null, startLeft = 0, moved = false;
    row.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || row.scrollWidth <= row.clientWidth) return;
      if (e.target.closest('a, button, input, select, textarea, form')) return;
      startX = e.clientX; startLeft = row.scrollLeft; moved = false;
      row.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      row.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', () => {
      if (startX === null) return;
      startX = null;
      row.classList.remove('is-dragging');
    });
    row.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  };

  const run = () => document.querySelectorAll('[data-eo26-swipe]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // Re-run when a section is added or changed in the theme editor
  document.addEventListener('shopify:section:load', run);
})();
